<template>
    <b-modal ref="register-modal" id="modal-register" @hidden="initForm" :title="`My Event Cafe ${$t('userRegistration')}`" hide-footer>
      <ValidationObserver ref="observer" tag="span">
      <b-form ref="registerForm" @submit.stop.prevent="register">
          <div class="form-group">
            <select v-model="lang" @change="setLocale(lang)" class="float-right">
              <option value="en">English</option>
              <option value="es">Española</option> <!-- Spanish -->
              <option value="de">Deutsch</option> <!-- German -->
              <option value="fr">Français</option> <!-- French -->
              <option value="el">Ελληνικά</option> <!-- Greek -->
              <option value="nl">Nederlands</option> <!-- Dutch -->
              <option value="ru">Русский</option> <!-- Russian -->
            </select>
            <label>{{ $t('name') }}:</label>
            <div class="row">
              <div class="col-sm-6 pr-sm-1 mb-1 mb-sm-0">
                <ValidationProvider :name="$t('firstName')" rules="required" v-slot="{ errors }">
                  <b-input id="name" data-cy="inputName" type="text" :placeholder="$t('firstName')" v-model="name" />
                  <span data-cy="invalidFirstName" class="text-danger small">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="col-sm-6 pl-sm-1">
                <ValidationProvider :name="$t('lastName')" rules="required" v-slot="{ errors }">
                  <b-input id="last_name" data-cy="inputLastName" type="text" :placeholder="$t('lastName')" v-model="last_name" />
                  <span data-cy="invalidLastName" class="text-danger small">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>{{ $t('emailAddress') }}:</label>
            <div class="row">
              <div class="col-sm-6 pr-sm-1 mb-1 mb-sm-0">
                <ValidationProvider :name="$t('emailAddress')" rules="required|email" vid="email" v-slot="{ errors }">
                <b-input v-model.trim="email" data-cy="inputEmail" id="feedback-email" type="text" :placeholder="$t('emailAddress')" />
                <span data-cy="invalidEmail" class="text-danger small">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="col-sm-6 pl-sm-1">
                <ValidationProvider :name="$t('confirmEmailAddress')" rules="required|confirmed:email" v-slot="{ errors }">
                <b-input v-model.trim="email_confirmation" data-cy="inputConfirmEmail" id="confirm-userId" type="text" :placeholder="$t('confirmEmailAddress')" />
                <span data-cy="invalidEmailConfirm" class="text-danger small">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="ddNotifyMethod">{{ $t('notificationMethod') }}:</label>&nbsp;
            <b-link href="#" style="text-decoration: none" @click="showInformation($t('notificationMethod'), `${$t('notificationMethodHelp')}`)"><i class="mdi mdi-information-outline"></i> {{ $t('help') }}</b-link>
            <ValidationProvider :name="$t('notificationMethod')" rules="required" vid="notificationMethod" v-slot="{ errors }">
              <b-form-select data-cy="ddNotifyMethod" id="ddNotifyMethod" v-model="notificationMethod" :options="notify_options"></b-form-select>
              <span data-cy="invalidNotificationMethod" class="text-danger small">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <label for="feedback-phone">{{$t('cellPhone')}} (U.S. and Canada only)</label>&nbsp;
            <b-link href="#" style="text-decoration: none" @click="showInformation($t('cellPhone'), `${$t('cellPhonePolicy')}`)"><i class="mdi mdi-information-outline"></i> {{ $t('policy') }}</b-link>
            <ValidationProvider name="Cell Phone" rules="required_if:notificationMethod,Text|length:14" v-slot="{ errors }">
              <b-input-group>
                <template v-slot:prepend>
                  <b-input-group-text >+1</b-input-group-text>
                </template>
                <b-input id="feedback-phone" data-cy="inputPhone" type="tel" v-mask="'(###) ###-####'" v-model="phone" />
              </b-input-group>
              <span data-cy="invalidPhone" class="text-danger small">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <b-form-checkbox id="chkMention" data-cy="checkMention" v-model="smsNotifications" name="check-button" check>
              {{$t('notifyMe')}}
              <b-link href="#" style="text-decoration: none" @click="showInformation($t('textNotification'), $t('textNotificationHelp'))"><i class="mdi mdi-information-outline"></i> {{ $t('help') }}</b-link>
            </b-form-checkbox>
          </div>
          <div class="form-group">
            <label for="Password">{{$t('password')}}</label>
            <ValidationProvider :name="$t('password')" rules="required|min:4" vid="pass" v-slot="{ errors }">
                <b-input v-model="password" data-cy="inputPassword" id="password-feedback" type="password" :placeholder="$t('password')" />
                <span data-cy="invalidPassword" class="text-danger small">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <label for="Password Confirmation">{{$t('confirmPassword')}}</label>
            <ValidationProvider :name="$t('confirmPassword')" rules="required|confirmed:pass" v-slot="{ errors }">
                <b-input id="password-confirm" v-model="password_confirmation" data-cy="inputConfirmPassword" type="password" :placeholder="$t('confirmPassword')"  />
                <span data-cy="invalidPasswordConfirm" class="text-danger small">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider name="SMS Consent" rules="required_if:notificationMethod,Text" v-slot="{ errors }">
            <b-form-checkbox id="chkConsent" data-cy="chkConsent" v-model="smsConsent" name="check-button" check>
              {{ $t('smsConsent') }} </b-form-checkbox>
              <span data-cy="invalidConsent" class="text-danger small">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <span class="float-left mb-2" style="font-size: 14px">{{$t('smsPolicy')}}</span>
          <div class="w-100 mt-2 mb-0 clearfix">
            <label class="text-danger float-left" >{{ error }}</label>
            <p class="float-right ml-2"><b-button data-cy="btnSubmit" variant="success" type="button" @click="register()" :disabled="working">{{$t('submit')}} <b-spinner small v-if="working"></b-spinner></b-button></p>
            <p class="float-right"><button data-cy="btnCancel" type="button" class="btn btn-secondary" @click="close()">{{$t('close')}}</button></p>
          </div>
      </b-form>
      </ValidationObserver>
    </b-modal>
</template>

<script>
import { mask } from 'vue-the-mask'
import { localize, ValidationObserver, ValidationProvider, extend } from 'vee-validate'
// eslint-disable-next-line
import { required, required_if, length, email, confirmed, min } from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'
import es from 'vee-validate/dist/locale/es.json'
import el from 'vee-validate/dist/locale/el.json'
import fr from 'vee-validate/dist/locale/fr.json'
import ru from 'vee-validate/dist/locale/ru.json'
import nl from 'vee-validate/dist/locale/nl.json'
import { loadLanguageAsync } from '../i18n'

localize({ en, es, el, fr, nl, ru })
// extend('required', { ...required, message: '{_field_} is required' })
extend('required', required)
extend('required_if', required_if)
extend('length', length)
extend('email', { ...email, message: 'Not a valid Email Address' })
extend('confirmed', { ...confirmed, message: '{target} does not match' })
extend('min', { ...min, message: '{_field_} must be at least 4 characters' })

export default {
  name: 'RegisterModal',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  directives: { mask },
  data () {
    return {
      lang: this.$i18n.locale,
      name: '',
      last_name: '',
      email: '',
      email_confirmation: '',
      phone: '',
      smsNotifications: false,
      smsConsent: false,
      password: '',
      password_confirmation: '',
      notificationMethod: '',
      notify_options: [
        { value: '', text: '<Please Select>' },
        { value: 'Email', text: 'Email' },
        { value: 'Text', text: 'Text' }
      ],
      working: false,
      error: ''
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  mounted () {
    this.initForm()
    // console.log('locale: ' + this.$i18n.locale)
    localize(this.$i18n.locale)
    if (this.$route.query.email) {
      this.email = this.$route.query.email
    }
  },
  methods: {
    setLocale (locale) {
      // this.$i18n.locale = locale
      loadLanguageAsync(locale)
      localize(locale)
    },
    register () {
      // this validation step shouldn't be necessary, but the invalid flag isn't working consistently for required_if
      this.$refs.observer.validate()
        .then((success) => {
          if (success) {
            this.working = true
            this.error = ''
            let data = {
              name: this.name + ' ' + this.last_name,
              email: this.email,
              phone: this.phone,
              password: this.password,
              smsNotifications: this.smsNotifications,
              notificationMethod: this.notificationMethod,
              smsConsent: this.smsConsent
            }
            console.log('Attempting to Call Store Register: ' + JSON.stringify(data))
            this.$store
              .dispatch('register', data)
              .then(() => {
                this.working = false
                this.$refs['register-modal'].hide()
                this.$emit('registrationFinished')
              })
              .catch(err => {
                this.working = false
                if (err.response) {
                  console.log('Error: ' + JSON.stringify(err.response))
                  this.error = err.response.data.errors[0]
                } else {
                  this.error = err
                }
              })
          }
        })
    },
    initForm () {
      this.name = ''
      this.last_name = ''
      this.email = ''
      this.email_confirmation = ''
      this.phone = ''
      this.smsNotifications = false
      this.password = ''
      this.password_confirmation = ''
      this.notificationMethod = 'Text'
      this.working = false
      this.error = ''
    },
    close () {
      this.$bvModal.hide('modal-register')
    },
    showInformation (title, message) {
      const h = this.$createElement
      const messageVNode = h('div', { domProps: { innerHTML: message } })
      this.$bvModal.msgBoxOk([messageVNode], {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        headerClass: 'p-2',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
